<mc-maximize-dialog-button class="mc-dialog-floating-maximize-button" [dialogRef]="dialogRef" maximizedWidth="95vw" maximizedHeight="90vh" (resized)="logTabPanel?.checkViewportSize()"></mc-maximize-dialog-button>
<button type="button" mat-icon-button class="mc-dialog-floating-close-button" tabindex="-1" (click)="closeDialog()">
  <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
</button>

<mc-loader *ngIf="loadingState.loading$ | async"></mc-loader>

<div *ngIf="loadingState.generalError$ | async as generalError" class="error-pane">
  <mc-errors-expansion-panel [generalError]="generalError" [detailedErrors]="loadingState.detailedErrors$ | async"></mc-errors-expansion-panel>
</div>

<mc-switch-board color="secondary">
  <mc-switch-board-bar class="mc-spring-board">
    <ng-container *ngIf="build$ | async as build">
      <div class="mc-spring-board-header">
        <mc-build-avatar class="mc-build-profile-dialog-bar-avatar" [build]="build" [disabled]="true"></mc-build-avatar>
        <ul class="mc-property-list mc-profile-switch-board-bar-section">
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Project: </span>
            <mc-project-avatar class="mc-property-value" [project]="project$ | async" [showAvatar]="false" [truncate]="true"></mc-project-avatar>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Target: </span>
            <mc-target-avatar class="mc-property-value" [branchName]="build.BranchName" [project]="project$ | async" [targetPath]="build.TargetPath" [showAvatar]="false" [truncate]="true"></mc-target-avatar>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Branch: </span>
            <mc-branch-avatar class="mc-property-value" [branchName]="build.BranchName" [project]="project$ | async" [showAvatar]="false" [truncate]="true"></mc-branch-avatar>
          </li>
        </ul>
        <p *ngIf="build.LinkedToLiveSite" class="mc-profile-switch-board-bar-section text-light-weight">
          <mat-icon fontSet="project-titan" fontIcon="icon-linked-to-live-site" class="mc-centered-text-icon"></mat-icon> &nbsp;
          Linked to a "Live" site
        </p>
        <p class="mc-profile-switch-board-bar-section text-light-weight">
          <ng-container *ngIf="build.IsKept || build.LinkedToLiveSite">
            <mat-icon *ngIf="build.IsKept || build.LinkedToLiveSite" fontSet="project-titan" fontIcon="icon-completed-filled" class="mc-centered-text-icon"></mat-icon> &nbsp;
          </ng-container>
          {{ build.IsKept || build.LinkedToLiveSite ? 'Set' : 'Not set' }} to "Keep"
        </p>
        <p *ngIf="build.Process?.LastProcessAttempt?.Status !== null && build.Process?.LastProcessAttempt?.Status !== undefined" [ngClass]="getTextColorClassForBuildState(build)">
          <mat-icon *ngIf="build.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Complete" fontSet="project-titan" fontIcon="icon-checkmark" class="mc-centered-text-icon"></mat-icon>
          <mat-icon *ngIf="build.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Canceled" fontSet="project-titan" fontIcon="icon-stopbuildcommand" class="mc-centered-text-icon"></mat-icon>
          <mat-icon *ngIf="build.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Failed || build.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Aborted" fontSet="project-titan" fontIcon="icon-close" class="mc-centered-text-icon"></mat-icon>
          &nbsp;{{ getStatusDisplayText(build) }}
          <ng-container *ngIf="build.IsStopped">
            after {{ build.RanFor | mcDuration }}
          </ng-container>
        </p>
      </div>

      <div class="mc-spring-board-body">
        <p class="mc-profile-switch-board-bar-section text-light-weight">
          {{ build.Description }}
        </p>
      </div>

      <mat-nav-list class="mc-spring-board-footer mc-list-text-size-normal mc-list-text-weight-normal mc-list-bg-dark mc-list-compact">
        <ng-container *ngIf="showCancelBuildTab$ | async">
          <a href="#" mat-list-item mcPreventDefault="click" (click)="onCancelBuildClicked(build)">
            <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-stopbuildcommand" color="warn-muted"></mat-icon> Cancel Build
          </a>
          <mat-divider></mat-divider>
        </ng-container>
        <a href="#" mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="buildProfileTab === BuildProfileTab.Overview" (click)="buildProfileTab = BuildProfileTab.Overview">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-overview" color="primary"></mat-icon> Overview
        </a>
        <a *ngIf="showSettingsTab$ | async" href="#" mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="buildProfileTab === BuildProfileTab.Settings" (click)="buildProfileTab = BuildProfileTab.Settings">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-gear" color="primary"></mat-icon> Settings
        </a>
        <a *ngIf="showLogTab$ | async" href="#" mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="buildProfileTab === BuildProfileTab.Log" (click)="buildProfileTab = BuildProfileTab.Log">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-openbuildlogcommand" color="primary"></mat-icon> Log
        </a>
        <a *ngIf="showViewOutputTab$ | async" href="#" mat-list-item mcPreventDefault="click" (click)="onViewOutputClicked(build)">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-eye-open" color="primary"></mat-icon> View Output
        </a>
        <a *ngIf="showDownloadBuildTab$ | async" href="#" mat-list-item mcPreventDefault="click" (click)="onDownloadBuildClicked(build)">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-download" color="primary"></mat-icon> Download Build
        </a>
        <a *ngIf="showDeleteTab$ | async" href="#" mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="buildProfileTab === BuildProfileTab.Delete" (click)="buildProfileTab = BuildProfileTab.Delete">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-trash" color="primary"></mat-icon> Delete Build
        </a>
      </mat-nav-list>
    </ng-container>
  </mc-switch-board-bar>

  <mc-switch-board-content [ngSwitch]="buildProfileTab" class="mc-spring-board">
    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="BuildProfileTab.Overview" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Overview">
        <mc-build-overview [build]="build$ | async"></mc-build-overview>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="BuildProfileTab.Settings" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Settings">
        <mc-build-settings-form [build]="build$ | async" (cancel)="onCancel()" (saved)="onSaved(BuildProfileForm.Settings)"></mc-build-settings-form>
      </mat-tab>
    </mat-tab-group>

    <ng-container *ngSwitchCase="BuildProfileTab.Log">
      <mc-log-tab-panel *ngIf="build$ | async as build"
        [streamUrl]="logStreamUrl"
        [sourceLinkResolver]="resolveBuildSourceLink"
        [emptyLabelOverride]="emptyLabelOverride"
        [loading]="logPrepareLoadingState.loading$ | async"
        [generalError]="logPrepareLoadingState.generalError$ | async"
        [detailedErrors]="logPrepareLoadingState.detailedErrors$ | async"
        [canDownloadLog]="canDownloadLog$ | async"
        [logUnavailable]="logUnavailable$ | async"
        gridId="build-logs-dialog-grid"
        settingsKey="build-logs-grid:type-filter"
        emptySubject="this build"
        (downloadLog)="onDownloadLogClicked(build)">
      </mc-log-tab-panel>
    </ng-container>

    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="BuildProfileTab.Delete" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Delete Build">
        <mc-build-deletion-form [build]="build$ | async" (cancel)="onCancel()" (deleted)="onSaved(BuildProfileForm.Delete)"></mc-build-deletion-form>
      </mat-tab>
    </mat-tab-group>
  </mc-switch-board-content>
</mc-switch-board>